/**
 * Campaign V3 AIR navigation policy.
 *
 * Product rule: production campaign creeps (GROUND and AIR) follow authored
 * physical map paths. AIR may float visually (altitude / shadow) but must not
 * take diagonal grass shortcuts via dedicated air-a corridors.
 *
 * Dedicated AIR routes (`air-*`, movementClass AIR) remain supported for
 * DEV / experimental / future special maps. They must be selected explicitly
 * via group.routeId — campaign authoring helpers never auto-bind to them.
 */

export const CAMPAIGN_AIR_NAVIGATION = 'physical-path' as const

/** True when a route id is a dedicated off-road / corridor air track. */
export function isDedicatedAirRouteId(routeId: string | undefined | null): boolean {
  if (!routeId) return false
  return routeId === 'air' || routeId.startsWith('air')
}

/**
 * AIR enemies may navigate:
 * - GROUND routes → production campaign physical path
 * - AIR routes → explicit DEV / special maps only
 *
 * GROUND enemies may only use GROUND routes.
 */
export function routeAllowedForMovement(
  movementClass: 'GROUND' | 'AIR',
  routeMovementClass: 'GROUND' | 'AIR'
): boolean {
  if (movementClass === 'GROUND') return routeMovementClass === 'GROUND'
  return routeMovementClass === 'GROUND' || routeMovementClass === 'AIR'
}
